import React from 'react';
import { motion } from 'framer-motion';

const ResourceCenterSection = () => {
    return (
        <section
            className="w-full min-h-[500px] sm:min-h-[600px] lg:min-h-[650px] bg-cover bg-center bg-no-repeat relative flex items-center select-none text-left overflow-hidden relative z-50"
            style={{ backgroundImage: `url('/assets/sustainability/bg2.png')` }}
        >
            <div className="absolute inset-0 bg-black/10 pointer-events-none" />

            <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px] relative z-10">

                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.7, ease: "easeOut" }}
                    className="bg-white w-full max-w-[615px] p-[20px] sm:p-[30px] lg:p-[46px] flex flex-col items-start rounded-none"
                >

                    <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight leading-tight mb-5 font-sora">
                        Resource Center
                    </h2>

                    <p className="text-[#49577A] text-[14px] lg:text-[16px] leading-relaxed font-[500] font-graphik mb-8">
                        We're always finding new ways to reach and exceed our sustainability goals. Explore our latest reports for more insights.
                    </p>

                    <div className="group flex items-center gap-2 cursor-pointer">
                        <span className="text-[#01386A] font-sora font-[600] text-[14px] sm:text-[16px] tracking-wide transition-colors duration-200 group-hover:text-[#EA580C]">
                            Read More
                        </span>
                        <span className="text-[#EA580C] font-[700] text-[14px] sm:text-[16px] transition-transform duration-300 ease-out group-hover:translate-x-1.5">
                            &gt;
                        </span>
                    </div>

                </motion.div>

            </div>
        </section>
    );
};

export default ResourceCenterSection;